import { Translations } from "@aws-amplify/ui-components";
import { createStyles, Stack } from "@mantine/core";
import { DefaultComponents } from "@aws-amplify/ui-react/dist/types/components/Authenticator/hooks/useCustomComponents/defaultComponents";
import { RpiTitle, RpiSubTitle, RpiLabelText } from "@rpi/openapi-core";
import { I18n } from "aws-amplify";
import { getRoutePath } from "../../../hooks/useNavigateRoute";
import { RpaNavLink } from "../../../components/RpiLink";

const useSignInStyles = createStyles((theme) => ({
  authHeader: {
    alignItems: "center",
    gap: theme.spacing.lg,
    marginBottom: theme.spacing.lg,
  },
  authFooter: {
    alignItems: "center",
    gap: theme.spacing.md,
    marginTop: theme.spacing.lg,
  },
}));

export const signInComponent: DefaultComponents["SignIn"] = {
  Header() {
    const { classes } = useSignInStyles();
    return (
      <Stack className={classes.authHeader}>
        <img src="/logo.svg" width={94} height={94} />
        <RpiTitle>RPI Print API</RpiTitle>
        <RpiSubTitle>Welcome back.</RpiSubTitle>
      </Stack>
    );
  },
  Footer() {
    const { classes } = useSignInStyles();
    return (
      <Stack className={classes.authFooter}>
        <RpiLabelText>
          New to RPI Print API? <RpaNavLink to={getRoutePath("auth:sign-up")}>Sign Up</RpaNavLink>
        </RpiLabelText>
        <RpaNavLink to={getRoutePath("auth:reset-password")}>Forgot Password?</RpaNavLink>
      </Stack>
    );
  },
};

I18n.putVocabulariesForLanguage("en", {
  [Translations.SIGN_IN_TEXT]: "Sign in",
  "Incorrect username or password.":
    "Oops! Looks like that username and password combo didn't work. Give it another shot or hit 'Forgot Password' below to reset it.",
  "User does not exist.":
    "Oops! Looks like that username and password combo didn't work. Give it another shot or hit 'Forgot Password' below to reset it.",
});
